import { STS_MODULE_ID } from "./measurementModules";
import { translate } from "./locale";

// The module list API returns English `moduleName` / `description`, so the TUG
// modules are localized here by id. Unknown modules keep the backend text.
const MODULE_KEYS = {
  1: "tug_side",
  4: "tug_front",
};

const moduleKey = (module) => MODULE_KEYS[Number(module?.moduleId)];

export const getModuleName = (module) => {
  if (Number(module?.moduleId) === STS_MODULE_ID)
    return translate("sts", "name");
  const key = moduleKey(module);
  return key
    ? translate("testModule", `module_${key}_name`)
    : module?.moduleName || "";
};

export const getModuleDescription = (module) => {
  if (Number(module?.moduleId) === STS_MODULE_ID)
    return translate("sts", "description");
  const key = moduleKey(module);
  return key
    ? translate("testModule", `module_${key}_desc`)
    : module?.description || "";
};

export const getModuleBadge = (module) =>
  translate(
    "testModule",
    Number(module?.moduleId) === 4 ? "badge_front" : "badge_side",
  );
